<template>
  <div class="contract_info_area" id="contract_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="corporationNameLabel"
        :valueLabel="corporation.corporationName"
        :changeLabel="inputData.corporationName"
        :is-changed="corporation.corporationName !== inputData.corporationName"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationAddressLabel"
        :valueLabel="corporation.corporationAddress"
        :changeLabel="inputData.corporationAddress"
        :is-changed="
          corporation.corporationAddress !== inputData.corporationAddress
        "
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserDepartmentsLabel"
        :valueLabel="corporation.corporationUserDepartments"
        :changeLabel="inputData.corporationUserDepartments"
        :deleteLabel="corporation.corporationUserDepartments"
        :is-changed="
          corporation.corporationUserDepartments !==
            inputData.corporationUserDepartments
        "
        :is-deleted="inputData.corporationUserDepartments === ''"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserPositionLabel"
        :valueLabel="corporation.corporationUserPosition"
        :changeLabel="inputData.corporationUserPosition"
        :deleteLabel="corporation.corporationUserPosition"
        :is-changed="
          corporation.corporationUserPosition !==
            inputData.corporationUserPosition
        "
        :is-deleted="inputData.corporationUserPosition === ''"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserNameLabel"
        :valueLabel="corporation.corporationUserName"
        :changeLabel="inputData.corporationUserName"
        :is-changed="
          corporation.corporationUserName !== inputData.corporationUserName
        "
      ></valueLabelSection>
    </div>
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="corporationUserTelephoneNumberLabel"
        :valueLabel="corporation.corporationUserTelephoneNumber"
        :changeLabel="inputData.corporationUserTelephoneNumber"
        :is-changed="
          corporation.corporationUserTelephoneNumber !==
            inputData.corporationUserTelephoneNumber
        "
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="corporationUserMailAddressLabel"
        :valueLabel="corporation.corporationUserMailAddress"
        :changeLabel="inputData.corporationUserMailAddress"
        :is-changed="
          corporation.corporationUserMailAddress !==
            inputData.corporationUserMailAddress
        "
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="contractDateLabel"
        :valueLabel="corporation.contractDate"
        :changeLabel="dispDate(inputData.contractDate)"
        :is-changed="corporation.contractDate !== dispDate(inputData.contractDate)"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="availableDeviceCountsLabel"
        :valueLabel="corporation.availableDeviceCounts + '台'"
        :changeLabel="availableDeviceCounts"
        :is-changed="
          corporation.availableDeviceCounts !== inputData.availableDeviceCounts
        "
      ></valueLabelSection>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './updateValueLabelSection.vue'

export default {
  props: {
    contentHeight: String
  },
  data() {
    return {
      corporationNameLabel: '法人名',
      corporationAddressLabel: '法人住所',
      contractDateLabel: '契約日',
      corporationUserDepartmentsLabel: '法人担当者（部署）',
      corporationUserPositionLabel: '法人担当者（役職）',
      corporationUserNameLabel: '法人担当者（氏名）',
      corporationUserTelephoneNumberLabel: '法人担当者連絡先（電話）',
      corporationUserMailAddressLabel: '法人担当者連絡先（メール）',
      availableDeviceCountsLabel: '契約台数'
    }
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    inputData() {
      return this.$store.state.corporations.updateCorporation
    },
    availableDeviceCounts() {
      var counts = this.$store.state.corporations.updateCorporation
        .availableDeviceCounts
      return counts + '台'
    }
  },
  methods: {
    dispDate(dateStr) {
      const date = new Date(dateStr);
      const formatter = new Intl.DateTimeFormat('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      return formatter.format(date);
    }
  },
  components: {
    valueLabelSection
  }
}
</script>

<style scoped>
.detail_content {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/contractUpdateInfo.vue